/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
/* jscs:disable maximumLineLength */
import React, { PureComponent } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import PropTypes from 'prop-types';

class BadgeVerifiedPatient extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
  };

  render = () => (
    <SvgIcon width="113px" height="28px" viewBox="0 0 113 28" className={this.props.className}>
      <title>Badge Verified Patient Icon</title>
      <g id="CDP" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Badge-Verified-Patient-Copy">
          <rect
            id="Rectangle"
            fill="#40B6F5"
            fillRule="nonzero"
            x="13"
            y="4"
            width="100"
            height="20"
            rx="10"
          />
          <circle
            id="Oval"
            stroke="#FFFFFF"
            fill="#40B6F5"
            fillRule="nonzero"
            cx="14"
            cy="14"
            r="13.5"
          />
          <path
            d="M12.4179582,18.7714849 L8.17773395,14.5566512 C8.05924452,14.4381618 8,14.2858184 8,14.0996211 C8,13.9134237 8.05924452,13.7610803 8.17773395,13.6425909 L9.11718484,12.7285306 C9.23567427,12.5931144 9.38378576,12.5254061 9.56151971,12.5254061 C9.73925367,12.5254061 9.89582894,12.5931144 10.0312452,12.7285306 L12.8749884,15.5722738 L18.9687238,9.47853833 C19.1041401,9.34312211 19.2607153,9.27541381 19.4384493,9.27541381 C19.6161832,9.27541381 19.7642947,9.34312211 19.8827842,9.47853833 L20.8222351,10.3925986 C20.9407245,10.5110881 20.999969,10.6634315 20.999969,10.8496288 C20.999969,11.0358262 20.9407245,11.1881695 20.8222351,11.306659 L13.3320185,18.7714849 C13.2135291,18.9069011 13.0611857,18.9746094 12.8749884,18.9746094 C12.688791,18.9746094 12.5364476,18.9069011 12.4179582,18.7714849 Z"
            id=""
            fill="#FFFFFF"
          />
          <text
            id="Verified-Patient"
            fontFamily="Circular-Pro-Book-S, Roboto"
            fontSize="10"
            fontWeight="300"
            fill="#FFFFFF"
          >
            <tspan x="33" y="17">
              Verified Patient
            </tspan>
          </text>
        </g>
      </g>
    </SvgIcon>
  );
}

export default BadgeVerifiedPatient;
